import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class ProjectCompletionService {
  public recordId = new BehaviorSubject(null)

  constructor(private _HttpClient:HttpClient) { }

  GetProjectCompletion(projectId:any):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ProjectCompletion/GetDB?projectId=${projectId}`);
  }
  GetProjectCompletionByid(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ProjectCompletion/GetByIdDB?Id=${id}`);
  }
  GetProjectCompletionPaged(pager:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/ProjectCompletion/GetPagedDB`,pager);
  }
  DeleteProjectCompletion(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ProjectCompletion/Delete?id=${id}`);
  }

  CreateProjectCompletion(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/ProjectCompletion/Create`,data);
  }
  UpdateProjectCompletion(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/ProjectCompletion/Update`,data)
  }
}
